<template>
  <div class="container"> </div>
</template>

<script>
import API from '@/api'
import { getUserThroughCode, setItem, isWxPlatform } from '@/utils/comUtils'
import { mcToast } from '@/utils/mcSdkUtils'
export default {
  name: 'PageWechatCode',
  data() {
    return {
      code: this.$route.query.code,
      appId: this.$route.query.appId.replace('token', ''), // appid会被拼接上token，未定位到哪里拼接的，先截取字符解决
      accessToken: '',
      openid: '',
      userInfo: {}
    }
  },
  mounted() {
    // 回调页面
    if (this.code) {
      setItem('weixinCode', this.code)
      setItem('weixinAppId', this.appId)
      if (isWxPlatform()) {
        // 获取用户信息
        // this.getLoginUserInfo()
        this.$router.push({
          path: '/',
          query: this.$route.query
        })
      } else {
        // 根据 code 获取网页授权token
        this.getWeixinAccessToken()
      }
    } else {
      getUserThroughCode()
    }
  },
  methods: {
    // 获取用户信息
    getLoginUserInfo() {
      API.getWechatUserInfo({
        appId: this.appId,
        code: this.code
      }).then(res => {
        if (res && res.result && res.result !== '0') {
          return false
        }
      })
    },
    // 获取网页授权token
    async getWeixinAccessToken() {
      // 获取accessToken，获取userInfo
      try {
        const { accessToken, openid, result, message } =
          await API.getWechatAccessToken({
            code: this.code
          })
        if (!result) {
          setItem('weixinAccessToken', accessToken)
          setItem('weixinOpenid', openid)
          this.accessToken = accessToken
          this.openid = openid
          this.getWeixinUserInfo()
        } else {
          mcToast({
            msg: message || '获取网页授权失败！'
          })
        }
      } catch (error) {
        mcToast({
          msg: '获取网页授权失败！'
        })
      }
    },
    // 获取微信用户信息
    async getWeixinUserInfo() {
      try {
        const userInfo = await API.getWechatUserInfo({
          accessToken: this.accessToken,
          openId: this.openid
        })
        if (userInfo.unionid) {
          setItem('weixinUserInfo', userInfo)
          this.userInfo = userInfo
          console.log(`success-->`, userInfo)
          this.checkLoginStatus()
        } else {
          mcToast({
            msg: '获取微信用户信息失败！'
          })
        }
      } catch (error) {
        mcToast({
          msg: '获取微信用户信息失败！'
        })
      }
    },
    // 检测登录状态
    async checkLoginStatus() {
      let loginStatus = null
      // todo 暂时去掉校验，有问题
      // try {
      //   loginStatus = await API.magicCheckLogin()
      // } catch (error) {
      //   loginStatus = false
      // }
      if (loginStatus) {
        // setItem('weixinUserInfo', this.userInfo)
        this.$router.replace('/')
      } else {
        console.log(`当前暂无登录状态-->`, loginStatus)
        // 通过 unionid 校验微信小程序是否绑定过魔蓝账号
        const res = await API.checkIsBindMDAccount({
          unionid: this.userInfo.unionid
        })
        if (res) {
          console.log(`success--->`, res)
          // 如果存在账号 直接登录
          const detail = await API.magicLoginByUnionid({
            unionid: this.userInfo.unionid,
            accountId: res
          })
          this.userInfo.accountId = detail.accountId
          setItem('weixinUserInfo', this.userInfo)
          console.log(`detail---success:`, detail)
          if (detail) {
            mcToast({ msg: '登录成功！' })
            setTimeout(() => {
              this.$router.replace('/')
            }, 300)
          }
        } else {
          this.$router.replace({
            name: 'PageWechatLoginAuth'
          })
        }
        // 跳转登录授权页面
      }
    }
  }
}
</script>

<style></style>
